import { createColumnHelper } from '@tanstack/react-table';
import { SearchVariantItem } from '@texas/api/endpoints/search/searchVariantsTypes';
import { clientEndpoints } from '@texas/clientEndpoints';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { ExpandImage } from '@texas/components/shared/image/ExpandImage';
import { TFunction } from 'i18next';
import { Image, Text } from '@chakra-ui/react';
import placeholderImg from '@texas/assets/placeholder-50.png';

export function createHeatmapArticleColumns(t: TFunction) {
  const columnHelper = createColumnHelper<SearchVariantItem>();

  return [
    columnHelper.accessor('itemCode', {
      cell: (info) => (
        <AngularNavLink
          to="article"
          navobj={{ articleId: info.row.original.articleId }}
        >
          {info.getValue()}
        </AngularNavLink>
      ),
      header: t('general.itemCode'),
    }),
    columnHelper.accessor('imageIdentifier', {
      cell: (info) => (
        <ExpandImage identifier={info.getValue()} variant="scale">
          <Image
            boxSize="12"
            src={
              info.getValue()
                ? clientEndpoints.previewImage(info.getValue(), 256)
                : undefined
            }
            fallbackSrc={placeholderImg}
            objectFit="contain"
          />
        </ExpandImage>
      ),
      header: t('general.photo'),
      enableSorting: false,
    }),
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: t('general.description'),
      enableSorting: false,
    }),
    columnHelper.accessor('customerName', {
      cell: (info) => (
        <AngularNavLink
          to="customer"
          navobj={{ customerId: info.row.original.customerId }}
        >
          {info.getValue()} - {info.row.original.customerIdentifier}
        </AngularNavLink>
      ),
      header: t('general.brand'),
      enableSorting: false,
    }),
    columnHelper.accessor('suppliers', {
      cell: (info) => <Text noOfLines={2}>{info.getValue()}</Text>,
      header: (t as any)('searchArticles.suppliers'),
      enableSorting: false,
    }),
    columnHelper.accessor('branch', {
      cell: (info) => info.getValue(),
      header: t('general.branch'),
      enableSorting: false,
    }),
    columnHelper.accessor('productGroup', {
      cell: (info) => info.getValue(),
      header: t('general.productGroup'),
      enableSorting: false,
    }),
    columnHelper.accessor('material', {
      cell: (info) => info.getValue(),
      header: t('general.material'),
      enableSorting: false,
    }),
  ];
}
